export let WidgetClosingTrigger = /*#__PURE__*/function (WidgetClosingTrigger) {
  WidgetClosingTrigger["CloseButton"] = "close_button";
  WidgetClosingTrigger["HelpButton"] = "help_button";
  WidgetClosingTrigger["ClickOutsideWidget"] = "click_outside_widget";
  WidgetClosingTrigger["ChatbotConversation"] = "chatbot_conversation";
  WidgetClosingTrigger["NewTabOpened"] = "new_tab_opened";
  return WidgetClosingTrigger;
}({});
//# sourceMappingURL=widgetClosingTrigger.js.map